/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfigResponseEchoUserGroups
 */
export interface ConfigResponseEchoUserGroups {
    /**
     * 
     * @type {string}
     * @memberof ConfigResponseEchoUserGroups
     */
    controlled?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigResponseEchoUserGroups
     */
    registered?: string;
}

/**
 * Check if a given object implements the ConfigResponseEchoUserGroups interface.
 */
export function instanceOfConfigResponseEchoUserGroups(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ConfigResponseEchoUserGroupsFromJSON(json: any): ConfigResponseEchoUserGroups {
    return ConfigResponseEchoUserGroupsFromJSONTyped(json, false);
}

export function ConfigResponseEchoUserGroupsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigResponseEchoUserGroups {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'controlled': !exists(json, 'controlled') ? undefined : json['controlled'],
        'registered': !exists(json, 'registered') ? undefined : json['registered'],
    };
}

export function ConfigResponseEchoUserGroupsToJSON(value?: ConfigResponseEchoUserGroups | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'controlled': value.controlled,
        'registered': value.registered,
    };
}

